import React from 'react';
import {
  Card,
  TextField,
  Typography,
} from '@material-ui/core';


const RequestPromotionSpecialInstructions = ({
  values,
  handleChange,
  handleBlur,
  touched,
  errors
}) => {
  return (
    <Card className="p-5 mt-4" elevation={0}>
      <Typography variant="h5" className="font-bold mb-5">
        Graphic Special Instructions
      </Typography>
      <TextField
        fullWidth
        value={values.specialInstructions}
        name="specialInstructions"
        multiline
        rows={4}
        variant="outlined"
        onChange={handleChange}
        onBlur={handleBlur}
        error={touched.specialInstructions && Boolean(errors.specialInstructions)}
        helperText={touched.specialInstructions && errors.specialInstructions}
      />
    </Card>
  );
};

export default RequestPromotionSpecialInstructions;
